import { SelectableSearchParameter } from './selectable-search-parameter';

export enum BoardTypeSearchParameter {
  ATTACHED_TO_FACADE = 'ATTACHED_TO_FACADE',
  BALCONY = 'BALCONY',
  STRETCHED = 'STRETCHED',
  ON_POSTS = 'ON_POSTS',
  ON_STONES = 'ON_STONES',
  WINDOW = 'WINDOW',
  OTHER = 'OTHER',
  DIVERGENT = 'DIVERGENT'
}

export const ALL_BOARD_TYPE_SEARCH_PARAMETERS: SelectableSearchParameter<
  BoardTypeSearchParameter
>[] = [
  { key: BoardTypeSearchParameter.ATTACHED_TO_FACADE, display: 'Gevel' },
  { key: BoardTypeSearchParameter.BALCONY, display: 'Balkon' },
  { key: BoardTypeSearchParameter.STRETCHED, display: 'Opgespannen' },
  { key: BoardTypeSearchParameter.ON_POSTS, display: 'Op palen' },
  { key: BoardTypeSearchParameter.ON_STONES, display: 'Op stenen' },
  { key: BoardTypeSearchParameter.WINDOW, display: 'Raam' },
  { key: BoardTypeSearchParameter.OTHER, display: 'Ander plaatsingstype' },
  { key: BoardTypeSearchParameter.DIVERGENT, display: 'Afwijkend bordtype' }
];

export const ONLY_BOARD_BOARD_TYPE_SEARCH_PARAMETERS: SelectableSearchParameter<
  BoardTypeSearchParameter
>[] = [
  { key: BoardTypeSearchParameter.ATTACHED_TO_FACADE, display: 'Gevel' },
  { key: BoardTypeSearchParameter.STRETCHED, display: 'Opgespannen' },
  { key: BoardTypeSearchParameter.ON_POSTS, display: 'Op palen' },
  { key: BoardTypeSearchParameter.ON_STONES, display: 'Op stenen' },
  { key: BoardTypeSearchParameter.OTHER, display: 'Ander plaatsingstype' }
];

export const ONLY_IP_BOARD_TYPE_SEARCH_PARAMETERS: SelectableSearchParameter<
  BoardTypeSearchParameter
>[] = [
  { key: BoardTypeSearchParameter.ATTACHED_TO_FACADE, display: 'Gevel' },
  { key: BoardTypeSearchParameter.STRETCHED, display: 'Opgespannen' },
  { key: BoardTypeSearchParameter.ON_POSTS, display: 'Op palen' },
  { key: BoardTypeSearchParameter.ON_STONES, display: 'Op stenen' },
  { key: BoardTypeSearchParameter.DIVERGENT, display: 'Afwijkend bordtype' }
];
